export default "__VITE_ASSET__C_t61PcZ__"